var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "stat-content",
    "class": _vm.contentClasses
  }, [_vm.icon ? _c('div', {
    staticClass: "stat-icon-bg"
  }, [_c('v-icon', {
    attrs: {
      "size": _vm.iconBgSize,
      "color": "primary-light"
    }
  }, [_vm._v(" " + _vm._s(_vm.iconName(_vm.icon)) + " ")])], 1) : _vm._e(), _c('div', {
    staticClass: "stat-main"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_c('div', {
    staticClass: "stat-header-left"
  }, [_c('h3', {
    staticClass: "stat-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.subtitle ? _c('div', {
    staticClass: "stat-subtitle",
    "class": _vm.subtitleClasses
  }, [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]) : _vm._e()]), _vm.warning ? _c('button', {
    staticClass: "stat-warning-btn",
    "class": {
      'stat-warning-btn--active': _vm.warningActive
    },
    attrs: {
      "type": "button",
      "aria-label": _vm.warningLabel || undefined,
      "title": _vm.warningLabel || undefined
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('warning-click', $event);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "warning",
      "size": _vm.warningIconSize
    }
  }, [_vm._v(" mdi-alert ")])], 1) : _vm.icon && !_vm.iconShadowOnly ? _c('div', {
    staticClass: "stat-header-icon"
  }, [_c('v-icon', {
    attrs: {
      "size": _vm.iconSize,
      "color": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.iconName(_vm.icon)) + " ")])], 1) : _vm._e()]), _c('div', {
    staticClass: "stat-values"
  }, [_vm.variant === 'create' ? [_c('div', {
    staticClass: "stat-value-wrapper stat-value-wrapper--create"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v(_vm._s(_vm.iconName(_vm.icon || "plus")))])], 1)] : _vm.loading ? [_c('div', {
    staticClass: "stat-value stat-value--loading",
    "class": _vm.valueClasses
  }, [_c('div', {
    staticClass: "stat-loading-spinner"
  }), _c('span', [_vm._v(_vm._s(_vm.$translate("loading")))])]), _vm.secondaryValue !== null && _vm.secondaryValue !== undefined ? _c('div', {
    staticClass: "stat-secondary-value stat-secondary-value--loading",
    "class": _vm.secondaryValueClasses
  }, [_vm._v("   ")]) : _vm._e()] : [_c('div', {
    staticClass: "stat-value-wrapper"
  }, [_vm.secondaryAbove && _vm.secondaryValue !== null && _vm.secondaryValue !== undefined ? _c('div', {
    staticClass: "stat-secondary-value",
    "class": _vm.secondaryValueClasses
  }, [_vm._v(" " + _vm._s(_vm.formattedSecondaryValue) + " ")]) : _vm._e(), _c('div', {
    staticClass: "stat-value",
    "class": _vm.valueClasses
  }, [_vm._v(" " + _vm._s(_vm.formattedStat)), _vm.displayValueSuffix ? _c('span', {
    staticClass: "stat-value-suffix"
  }, [_vm._v(_vm._s(_vm.displayValueSuffix))]) : _vm._e()]), !_vm.secondaryAbove && _vm.secondaryValue !== null && _vm.secondaryValue !== undefined ? _c('div', {
    staticClass: "stat-secondary-value",
    "class": _vm.secondaryValueClasses
  }, [_vm._v(" " + _vm._s(_vm.formattedSecondaryValue) + " ")]) : _vm._e()])]], 2)]), _c('div', {
    staticClass: "stat-accent-bar",
    "class": _vm.accentBarClasses
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }